import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import CardDropdown from "components/common/CardDropdown";
import IconButton from "components/common/IconButton";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { settings } from "config";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  Form,
  OverlayTrigger,
  SplitButton,
  Tooltip,
} from "react-bootstrap";
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "./styles.css";
import { VouchersAPI } from "api";
import { useSettingContext } from "context/SettingContext";
import { formatDate } from "date-fns";
import PageTitle from "utils/PageTitle";
import { FaPlus } from "react-icons/fa";
import { usePermission } from "context/PermissionContext";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

export default function WeighmentEntryTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const columnApiRef = useRef();
  const gridRef = useRef();
  const { hasPermissionByName, loading } = usePermission();

  const firstWeightVisible = hasPermissionByName("First Weight", "allowNew");
  const secondWeightVisible = hasPermissionByName("Second Weight", "allowNew");
  const finalWeightVisible = hasPermissionByName("Final Weight", "allowNew");

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs] = useState([
    {
      field: "turn",
      headerName: "Turn",
      hide: false,
      flex: 2,
    },
    {
      field: "number",
      headerName: "Number",
      hide: false,
      flex: 2,
    },
    {
      field: "date",
      headerName: "Date",
      hide: false,
      flex: 1.5,
      cellRenderer: (p) => {
        const date = p?.data?.date
          ? new Date(p.data?.date).toLocaleDateString()
          : "";
        return <div>{date}</div>;
      },
    },
    {
      field: "party",
      headerName: "Party",
      hide: false,
      flex: 2,
    },
    {
      field: "vehicleNumber",
      headerName: "Vehicle Number",
      hide: false,
      flex: 2,
    },

    // {
    //   field: "status",
    //   headerName: "Active",
    //   flex: 1.5,
    //   hide: false,
    //   filter: false,
    //   cellStyle: {
    //     display: "flex",
    //     // paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => (
    //     <Form.Check
    //       type="checkbox"
    //       id="statusSwitch"
    //       style={{ padding: "10px 0px" }}
    //       checked={p?.data.status}
    //     />
    //   ),
    // },
    {
      headerName: "Action",
      field: "action",
      flex: 1.5,
      filter: false,
      headerClass: "center-header",
      cellStyle: {
        display: "flex",
        justifyContent: "center",
      },
      cellRenderer: (p) => (
        <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              // as={Link}
              onClick={() =>
                // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
                // () =>
                handleRowClick(p.data)
              }
              // href="/products/add-product"
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdOutlineModeEdit />
              Edit
            </Dropdown.Item>
            {/* <Dropdown.Item
              // onClick={() => handleDelete()}
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdDeleteOutline />
              Delete
            </Dropdown.Item> */}
          </div>
        </CardDropdown>
      ),
    },
  ]);

  const handleRowClick = (data) => {
    if (data) {
      navigate(`${CONSTANT_ROUTES.WEIGHMENT_ADD}`, { state: data });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    // flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const onGridReady = useCallback(
    (e) => {
      gridApi = e.api;
      columnApi = e.columnApi;
      restoreState();
      // CostCenterAPI.get().then((res) => {
      //   e.api.applyTransaction({ add: res?.data?.data });
      // });
      e.api.setRowData([]);
    },
    [window]
  );

  const saveState = useCallback(() => {
    saveColumnState("weighments-table", columnApiRef);
  }, []);

  const restoreState = useCallback(() => {
    restoreColumnState("weighments-table", columnApiRef);
  }, []);

  const resetState = useCallback(() => {
    resetColumnState("weighments-table", columnApiRef);
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  const actions = [
    {
      key: "first",
      label: "First Weight",
      icon: <FaPlus size={14} />,
      visible: hasPermissionByName("First Weight", "allowNew"),
      route: CONSTANT_ROUTES.WEIGHMENT_ADD,
    },
    {
      key: "second",
      label: "Second Weight",
      icon: <FaPlus size={14} />,
      visible: hasPermissionByName("Second Weight", "allowNew"),
      route: CONSTANT_ROUTES.SECOND_WEIGHT_ADD,
    },
    {
      key: "final",
      label: "Final Weight",
      icon: <FaPlus size={14} />,
      visible: hasPermissionByName("Final Weight", "allowNew"),
      route: CONSTANT_ROUTES.FINAL_WEIGHT_ADD,
    },
  ];

  const visibleActions = actions?.filter((a) => a.visible);
  const primaryAction = visibleActions[0];
  const dropdownActions = visibleActions?.slice(1);

  return (
    <div>
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <PageTitle name=" Weighments | Weighment Entry" />

      <div
        className={`${
          isDarkBool || isDarkTheme || auto
            ? "ag-theme-quartz-dark"
            : "ag-theme-quartz"
        } rounded-0`} // applying the grid theme
        // style={{ height: "100vh" }} // the grid will fill the size of the parent container
      >
        <Card style={{ height: `calc(100vh - 4rem)`, overflow: "auto" }}>
          <Card.Header className="d-flex justify-content-between align-items-center">
            {/* <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
              {" "}
              Weighments | Weighment Entry
            </h5> */}
            <BreadCrumbTable title="Weighments" subTitle="Weighment Entry" />
            <div className="d-flex align-items-center gap-2">
              <Form className="position-relative">
                <FontAwesomeIcon
                  icon="search"
                  className="position-absolute text-400 search-box-icon"
                  style={{
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
                <Form.Control
                  type="search"
                  placeholder="Search..."
                  style={{
                    paddingLeft: "30px",
                  }}
                  aria-label="Search"
                  id="filter-text-box"
                  className="rounded-pill search-input"
                  onInput={onFilterTextBoxChanged}
                />
              </Form>

              {visibleActions?.length === 1 && (
                <Button
                  variant="falcon-default"
                  onClick={() => navigate(primaryAction?.route)}
                >
                  <div className="d-flex align-items-center">
                    {primaryAction?.icon}
                    <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                      {primaryAction?.label}
                    </span>
                  </div>
                </Button>
              )}

              {visibleActions?.length > 1 && (
                <SplitButton
                  as={ButtonGroup}
                  variant="falcon-default"
                  title={
                    <div
                      className="d-flex align-items-center"
                      onClick={() => navigate(primaryAction?.route)}
                    >
                      {primaryAction?.icon}
                      <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                        {primaryAction?.label}
                      </span>
                    </div>
                  }
                  align="end"
                >
                  {dropdownActions?.map((action, index) => (
                    <Dropdown.Item eventKey={index + 1} key={action?.key}>
                      <div
                        className="d-flex align-items-center"
                        onClick={() => navigate(action?.route)}
                      >
                        {action?.icon}
                        <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                          {action?.label}
                        </span>
                      </div>
                    </Dropdown.Item>
                  ))}
                </SplitButton>
              )}

              {/* <SplitButton
                as={ButtonGroup}
                variant="falcon-default"
                title={
                  <div
                    className="d-flex align-items-center"
                    onClick={() => navigate(CONSTANT_ROUTES.WEIGHMENT_ADD)}
                  >
                    <FaPlus size={14} />
                    <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                      First Weight
                    </span>
                  </div>
                }
                align="end"
                className=""
              >
                <Dropdown.Item eventKey="1">
                  {" "}
                  <div
                    className="d-flex align-items-center"
                    onClick={() => navigate(CONSTANT_ROUTES.SECOND_WEIGHT_ADD)}
                  >
                    <FaPlus size={14} />
                    <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                      Second Weight
                    </span>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item eventKey="2">
                  {" "}
                  <div
                    className="d-flex align-items-center"
                    onClick={() => navigate(CONSTANT_ROUTES.FINAL_WEIGHT_ADD)}
                  >
                    <FaPlus size={14} />
                    <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                      Final Weight
                    </span>
                  </div>
                </Dropdown.Item>
              </SplitButton> */}

              {/* {(firstWeightVisible ||
                secondWeightVisible ||
                finalWeightVisible) && (
                <SplitButton
                  as={ButtonGroup}
                  variant="falcon-default"
                  title={
                    firstWeightVisible ? (
                      <div
                        className="d-flex align-items-center"
                        onClick={() => navigate(CONSTANT_ROUTES.WEIGHMENT_ADD)}
                      >
                        <FaPlus size={14} />
                        <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                          First Weight
                        </span>
                      </div>
                    ) : secondWeightVisible ? (
                      <div
                        className="d-flex align-items-center"
                        onClick={() =>
                          navigate(CONSTANT_ROUTES.SECOND_WEIGHT_ADD)
                        }
                      >
                        <FaPlus size={14} />
                        <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                          Second Weight
                        </span>
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        onClick={() =>
                          navigate(CONSTANT_ROUTES.FINAL_WEIGHT_ADD)
                        }
                      >
                        <FaPlus size={14} />
                        <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                          Final Weight
                        </span>
                      </div>
                    )
                  }
                  align="end"
                >
                  {firstWeightVisible && !firstWeightVisible && (
                    <Dropdown.Item eventKey="1">
                      <div
                        className="d-flex align-items-center"
                        onClick={() => navigate(CONSTANT_ROUTES.WEIGHMENT_ADD)}
                      >
                        <FaPlus size={14} />
                        <span style={{ marginLeft: "10px", fontSize: "14px" }}>
                          First Weight
                        </span>
                      </div>
                    </Dropdown.Item>
                  )}

                  {secondWeightVisible &&
                    !(firstWeightVisible && secondWeightVisible) && (
                      <Dropdown.Item eventKey="2">
                        <div
                          className="d-flex align-items-center"
                          onClick={() =>
                            navigate(CONSTANT_ROUTES.SECOND_WEIGHT_ADD)
                          }
                        >
                          <FaPlus size={14} />
                          <span
                            style={{ marginLeft: "10px", fontSize: "14px" }}
                          >
                            Second Weight
                          </span>
                        </div>
                      </Dropdown.Item>
                    )}

                  {finalWeightVisible &&
                    !(
                      (firstWeightVisible && finalWeightVisible) ||
                      (secondWeightVisible &&
                        !firstWeightVisible &&
                        finalWeightVisible)
                    ) && (
                      <Dropdown.Item eventKey="3">
                        <div
                          className="d-flex align-items-center"
                          onClick={() =>
                            navigate(CONSTANT_ROUTES.FINAL_WEIGHT_ADD)
                          }
                        >
                          <FaPlus size={14} />
                          <span
                            style={{ marginLeft: "10px", fontSize: "14px" }}
                          >
                            Final Weight
                          </span>
                        </div>
                      </Dropdown.Item>
                    )}
                </SplitButton>
              )} */}

              {/* <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    First Weight
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.WEIGHMENT_ADD)}
                >
                  <span className="d-none d-sm-inline-block ms-1">
                    First Weight
                  </span>
                </IconButton>
              </OverlayTrigger>
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    Second Weight
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.SECOND_WEIGHT_ADD)}
                >
                  <span className="d-none d-sm-inline-block ms-1">
                    Second Weight{" "}
                  </span>
                </IconButton>
              </OverlayTrigger>
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    Final Weight
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.FINAL_WEIGHT_ADD)}
                >
                  <span className="d-none d-sm-inline-block ms-1">
                    Final Weight
                  </span>
                </IconButton>
              </OverlayTrigger> */}
              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item
                    onClick={saveState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Save State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={restoreState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={resetState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
          </Card.Header>

          <Card.Body className="p-0">
            <AgGridReact
              // rowData={rowData}
              ref={columnApiRef}
              pagination
              paginationPageSize={settings.paginationSize}
              onGridReady={onGridReady}
              columnDefs={colDefs}
              headerHeight={35}
              rowHeight={35}
              defaultColDef={defaultColDef}
              onRowDoubleClicked={(params) => handleRowClick(params.data)}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
